'use strict'

import ApiClient from './ApiClient'

export default class InfoRepository {
  /**
   * お知らせ一覧取得
   * @param params ページ番号
   * @returns {*}
   */
  getList (params) {
    return ApiClient().get(`/info-messages`, { params })
  }

  /**
   *指定されたIDのお知らせを取得
   * @param id ID
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/info-messages/${id}`)
  }

  /**
   * 指定された複数IDのお知らせを一括削除
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/info-messages/delete`, data)
  }

  /**
   * 指定されたIDのお知らせを既読
   * @param id ID
   * @returns {*}
   */
  put (id) {
    return ApiClient().put(`/info-messages/read/${id}`)
  }

  /**
   * 指定されたIDのお知らせを削除
   * @param id ID
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/info-messages/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/InfoRepository.js